import Axios from 'axios'
import { PREDICTOR_URL, getErrorMessage } from '@/main'

const state = {
  stateMetadata: null,
  statePredictorStructure: null,
  statePredictorOptions: null,
  statePredictorResult: null,
  predictorBuildDate: null,
}

const getters = {
  predictorMetadata: (state) => {
    return state.stateMetadata
  },
  predictorStructure: (state) => {
    return state.statePredictorStructure
  },
  predictorOptions: (state) => {
    return state.statePredictorOptions
  },
  predictorResult: (state) => {
    return state.statePredictorResult
  },
}

const mutations = {
  setPredictorMetadata: (state, payload) => {
    state.stateMetadata = payload
  },
  setPredictorStructure: (state, payload) => {
    state.statePredictorStructure = payload
  },
  setPredictorOptions: (state, payload) => {
    state.statePredictorOptions = payload
  },
  setPredictorResult: (state, payload) => {
    state.statePredictorResult = payload
  },
  resetPredictorResult: (state) => {
    state.statePredictorResult = null
  },
}

const actions = {}

export function preparePredictorMetadata(context) {
  Axios.get(`${PREDICTOR_URL}/metadata`)
    .then((response) => {
      context.commit('setFeatures', { predictor: { category: 'module' } })
      context.commit('setPredictorMetadata', response.data)
    })
    .catch((error) => {
      console.warn('PREDICTOR module is not available: %o', getErrorMessage(error))
      context.commit('removeFeature', { predictor: {} })
    })
}

export default {
  state,
  getters,
  mutations,
  actions,
}
